import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { JobDocHeaderLinkContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';
import { ApiVisa } from '../../../shared';


@Injectable({
  providedIn: 'root'
})
export class LoginDriverJobDocHdrLinkService extends BaseApiTemplateService<JobDocHeaderLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-dochdr-links/login-driver-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-dochdr-links/login-driver-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-dochdr-links/login-driver-ep';
    this.httpClient = http;
  }
  
  updateProofOfReceipt(jobDocHdrLinkGuid: string, dto: Object, visa: ApiVisa) {
    let url = this.apiUrl + '/updateProofOfReceipt/' + jobDocHdrLinkGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/updateProofOfReceipt/' + jobDocHdrLinkGuid;
    }
    return this.httpClient.put(url, dto, this.getHttpHeader(visa));
  }
}
